module.exports = __webpack_public_path__ + "static/media/document.bcac7983.svg";